module.exports = "/assets/41ac4a10c3fd78cbc46f5f12bcdd43a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KK.png
// module id = 2672
// module chunks = 0